import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PhoneVerificationService {
  private htmlResponse = {
    headers: new HttpHeaders({
        'Accept': 'text/html',
        'Content-Type': 'application/json'
    }),
    responseType: 'text'
};

  constructor(private httpClient: HttpClient) { }

  sendSmsCode(data): Observable<any> {
    return this.httpClient.post('/api/AccountApi/Send2FACode', data);
  }

  verifySmsCode(data): Observable<any> {
    return this.httpClient.post('/Account/Verify2FACode', data, 
      { headers: this.htmlResponse.headers, responseType: 'text'});
  }
}
